(() => {
  if (window.__fadropSearchEmptyResultsObserver) return;
  window.__fadropSearchEmptyResultsObserver = true;

  const injectCompactDesktopResultsCss = () => {
    if (document.getElementById('fadrop-search-compact-results-css')) return;

    const style = document.createElement('style');
    style.id = 'fadrop-search-compact-results-css';
    style.textContent = `
      @media screen and (min-width: 990px) {
        .header__search.fadrop-search-has-results details[open] > .search-modal,
        .header__search details[open]:has(predictive-search[open]) > .search-modal,
        .header__search details[open]:has(predictive-search[loading]) > .search-modal {
          position: fixed !important;
          inset: 0 0 auto 0 !important;
          width: 100vw !important;
          height: auto !important;
          min-height: 0 !important;
          max-height: none !important;
          background: transparent !important;
          overflow: visible !important;
        }

        .header__search.fadrop-search-has-results .search-modal__content,
        .header__search details[open]:has(predictive-search[open]) .search-modal__content,
        .header__search details[open]:has(predictive-search[loading]) .search-modal__content {
          display: grid !important;
          grid-template-columns: 24rem minmax(0, 1fr) 6.4rem !important;
          grid-template-rows: 5.2rem auto !important;
          column-gap: 5.2rem !important;
          row-gap: 3.2rem !important;
          width: 100vw !important;
          max-width: none !important;
          height: auto !important;
          min-height: 0 !important;
          padding: 1.6rem 6.8rem 3.2rem !important;
          background: #fff !important;
          overflow: visible !important;
        }

        .header__search.fadrop-search-has-results predictive-search.search-modal__form,
        .header__search details[open]:has(predictive-search[open]) predictive-search.search-modal__form,
        .header__search details[open]:has(predictive-search[loading]) predictive-search.search-modal__form {
          display: contents !important;
        }

        .header__search.fadrop-search-has-results predictive-search.search-modal__form > form.search-modal__form,
        .header__search details[open]:has(predictive-search[open]) predictive-search.search-modal__form > form.search-modal__form,
        .header__search details[open]:has(predictive-search[loading]) predictive-search.search-modal__form > form.search-modal__form {
          grid-column: 2 !important;
          grid-row: 1 !important;
          width: min(86rem, 100%) !important;
          justify-self: center !important;
        }

        .header__search.fadrop-search-has-results .predictive-search.predictive-search--header,
        .header__search details[open]:has(predictive-search[open]) .predictive-search.predictive-search--header,
        .header__search details[open]:has(predictive-search[loading]) .predictive-search.predictive-search--header {
          grid-column: 1 / -1 !important;
          grid-row: 2 !important;
          position: static !important;
          display: block !important;
          width: 100% !important;
          max-width: none !important;
          margin: 0 !important;
          padding: 0 !important;
          border: 0 !important;
          box-shadow: none !important;
          background: transparent !important;
          overflow: visible !important;
        }

        .header__search.fadrop-search-has-results .predictive-search__results-groups-wrapper,
        .header__search details[open]:has(predictive-search[open]) .predictive-search__results-groups-wrapper,
        .header__search details[open]:has(predictive-search[loading]) .predictive-search__results-groups-wrapper {
          display: grid !important;
          grid-template-columns: 24rem minmax(0, 1fr) !important;
          column-gap: 5.2rem !important;
          width: 100% !important;
          max-width: none !important;
          margin: 0 !important;
          padding: 0 !important;
          border: 0 !important;
          align-items: start !important;
        }

        .header__search.fadrop-search-has-results .predictive-search__result-group:first-child,
        .header__search details[open]:has(predictive-search[open]) .predictive-search__result-group:first-child,
        .header__search details[open]:has(predictive-search[loading]) .predictive-search__result-group:first-child {
          grid-column: 1 !important;
          width: 24rem !important;
          max-width: 24rem !important;
        }

        .header__search.fadrop-search-has-results .predictive-search__result-group:nth-child(2),
        .header__search.fadrop-search-has-results .predictive-search__result-group:last-child,
        .header__search details[open]:has(predictive-search[open]) .predictive-search__result-group:nth-child(2),
        .header__search details[open]:has(predictive-search[open]) .predictive-search__result-group:last-child,
        .header__search details[open]:has(predictive-search[loading]) .predictive-search__result-group:nth-child(2),
        .header__search details[open]:has(predictive-search[loading]) .predictive-search__result-group:last-child {
          grid-column: 2 !important;
          width: 100% !important;
          max-width: none !important;
          min-width: 0 !important;
        }

        .header__search.fadrop-search-has-results .predictive-search__result-group:nth-child(2) > .predictive-search__heading,
        .header__search.fadrop-search-has-results .predictive-search__result-group:last-child > .predictive-search__heading,
        .header__search details[open]:has(predictive-search[open]) .predictive-search__result-group:nth-child(2) > .predictive-search__heading,
        .header__search details[open]:has(predictive-search[open]) .predictive-search__result-group:last-child > .predictive-search__heading,
        .header__search details[open]:has(predictive-search[loading]) .predictive-search__result-group:nth-child(2) > .predictive-search__heading,
        .header__search details[open]:has(predictive-search[loading]) .predictive-search__result-group:last-child > .predictive-search__heading {
          display: none !important;
        }

        .header__search.fadrop-search-has-results #predictive-search-results-products-list,
        .header__search details[open]:has(predictive-search[open]) #predictive-search-results-products-list,
        .header__search details[open]:has(predictive-search[loading]) #predictive-search-results-products-list {
          display: grid !important;
          grid-template-columns: repeat(5, minmax(0, 1fr)) !important;
          column-gap: 1.6rem !important;
          row-gap: 0 !important;
          width: 100% !important;
          max-width: none !important;
          margin: 0 !important;
          padding: 0 !important;
          overflow: hidden !important;
        }

        .header__search #predictive-search-results-products-list .predictive-search__list-item:nth-child(n+6) {
          display: none !important;
        }

        .header__search #predictive-search-results-products-list .predictive-search__list-item,
        .header__search #predictive-search-results-products-list .predictive-search__item {
          display: block !important;
          width: 100% !important;
          min-width: 0 !important;
          min-height: 0 !important;
          margin: 0 !important;
          padding: 0 !important;
          background: transparent !important;
          color: #111 !important;
          text-align: left !important;
          text-decoration: none !important;
          grid-template-columns: none !important;
          grid-template-areas: none !important;
        }

        .header__search #predictive-search-results-products-list .predictive-search__image {
          display: block !important;
          width: 100% !important;
          height: auto !important;
          aspect-ratio: 1 / 1 !important;
          object-fit: contain !important;
          object-position: center !important;
          background: #f5f5f5 !important;
          border: 0 !important;
          border-radius: 0 !important;
        }

        .header__search #predictive-search-results-products-list .predictive-search__item-content {
          display: block !important;
          padding: 1.45rem 0 0 !important;
          text-align: left !important;
        }

        .header__search #predictive-search-results-products-list .predictive-search__item-heading {
          display: block !important;
          margin: 0 !important;
          color: #111 !important;
          font-size: 1.42rem !important;
          font-weight: 700 !important;
          line-height: 1.22 !important;
          letter-spacing: 0 !important;
          text-decoration: none !important;
        }

        .header__search #predictive-search-results-products-list .fadrop-mobile-predictive-meta,
        .header__search #predictive-search-results-products-list .predictive-search__item-vendor {
          display: block !important;
          margin: .48rem 0 0 !important;
          color: #737373 !important;
          font-size: 1.32rem !important;
          font-weight: 600 !important;
          line-height: 1.2 !important;
          letter-spacing: 0 !important;
        }

        .header__search #predictive-search-results-products-list .fadrop-mobile-predictive-price,
        .header__search #predictive-search-results-products-list .price {
          display: block !important;
          margin: 1.05rem 0 0 !important;
          color: #111 !important;
          font-size: 1.42rem !important;
          font-weight: 800 !important;
          line-height: 1.2 !important;
          letter-spacing: 0 !important;
        }

        .header__search #predictive-search-results-products-list .price *,
        .header__search #predictive-search-results-products-list .price__container,
        .header__search #predictive-search-results-products-list .price-item,
        .header__search #predictive-search-results-products-list .money {
          display: inline !important;
          margin: 0 !important;
          color: inherit !important;
          font-size: inherit !important;
          font-weight: inherit !important;
          line-height: inherit !important;
          letter-spacing: inherit !important;
        }

        .header__search details[open]:has(predictive-search[open]) .modal-overlay,
        .header__search details[open]:has(predictive-search[loading]) .modal-overlay,
        .header__search.fadrop-search-has-results details[open] .modal-overlay {
          position: absolute !important;
          inset: 0 !important;
          display: block !important;
          width: 100% !important;
          height: 100% !important;
          pointer-events: none !important;
        }

        .header__search details[open]:has(predictive-search[open]) .modal-overlay:after,
        .header__search details[open]:has(predictive-search[loading]) .modal-overlay:after,
        .header__search.fadrop-search-has-results details[open] .modal-overlay:after {
          position: absolute !important;
          top: 100% !important;
          right: 0 !important;
          bottom: auto !important;
          left: 0 !important;
          height: 100vh !important;
          content: "" !important;
          background: #000000a6 !important;
          backdrop-filter: blur(.65rem) !important;
          -webkit-backdrop-filter: blur(.65rem) !important;
        }

        .header__search.fadrop-search-has-results details[open] > .search-modal,
        .header__search details[open]:has(predictive-search[open]) > .search-modal,
        .header__search details[open]:has(predictive-search[loading]) > .search-modal {
          height: 60rem !important;
          min-height: 60rem !important;
          max-height: 60rem !important;
          background: #fff !important;
          overflow: visible !important;
        }

        .header__search.fadrop-search-has-results .search-modal__content,
        .header__search details[open]:has(predictive-search[open]) .search-modal__content,
        .header__search details[open]:has(predictive-search[loading]) .search-modal__content {
          grid-template-columns: 18rem minmax(0, 1fr) 6.4rem !important;
          grid-template-rows: 5.2rem minmax(0, 1fr) !important;
          column-gap: 4.4rem !important;
          row-gap: 3.2rem !important;
          height: 60rem !important;
          min-height: 60rem !important;
          max-height: 60rem !important;
          padding: 1.6rem 5.6rem 3.6rem !important;
          background: #fff !important;
          overflow: hidden !important;
        }

        .header__search.fadrop-search-has-results .predictive-search.predictive-search--header,
        .header__search details[open]:has(predictive-search[open]) .predictive-search.predictive-search--header,
        .header__search details[open]:has(predictive-search[loading]) .predictive-search.predictive-search--header {
          grid-column: 1 / -1 !important;
          width: 100% !important;
          max-width: none !important;
          overflow: visible !important;
        }

        .header__search.fadrop-search-has-results .predictive-search__results-groups-wrapper,
        .header__search details[open]:has(predictive-search[open]) .predictive-search__results-groups-wrapper,
        .header__search details[open]:has(predictive-search[loading]) .predictive-search__results-groups-wrapper {
          grid-template-columns: 24rem minmax(0, 1fr) !important;
          column-gap: 5.2rem !important;
          width: 100% !important;
          max-width: none !important;
          margin: 0 !important;
        }

        .header__search.fadrop-search-has-results #predictive-search-results-products-list,
        .header__search details[open]:has(predictive-search[open]) #predictive-search-results-products-list,
        .header__search details[open]:has(predictive-search[loading]) #predictive-search-results-products-list {
          grid-template-columns: repeat(5, minmax(0, 1fr)) !important;
          column-gap: 2.2rem !important;
          width: 100% !important;
          max-width: none !important;
          overflow: visible !important;
        }

        .header__search #predictive-search-results-products-list .fadrop-predictive-wishlist-button {
          width: clamp(3.2rem, 15%, 5.6rem) !important;
          height: clamp(3.2rem, 15%, 5.6rem) !important;
          min-width: clamp(3.2rem, 15%, 5.6rem) !important;
          min-height: clamp(3.2rem, 15%, 5.6rem) !important;
          top: clamp(.8rem, 5%, 1.4rem) !important;
          right: clamp(.8rem, 5%, 1.4rem) !important;
        }

        .header__search #predictive-search-results-products-list .fadrop-predictive-wishlist-button svg {
          width: 55% !important;
          height: 55% !important;
        }

        .header__search.fadrop-search-has-results details[open] .modal-overlay,
        .header__search details[open]:has(predictive-search[open]) .modal-overlay,
        .header__search details[open]:has(predictive-search[loading]) .modal-overlay {
          position: absolute !important;
          inset: 0 !important;
          z-index: 0 !important;
          pointer-events: none !important;
        }

        .header__search.fadrop-search-has-results details[open] .search-modal__content,
        .header__search details[open]:has(predictive-search[open]) .search-modal__content,
        .header__search details[open]:has(predictive-search[loading]) .search-modal__content {
          position: relative !important;
          z-index: 1 !important;
        }

        .header__search.fadrop-search-has-results details[open] .modal-overlay:after,
        .header__search details[open]:has(predictive-search[open]) .modal-overlay:after,
        .header__search details[open]:has(predictive-search[loading]) .modal-overlay:after {
          top: 100% !important;
        }

        .header__search.fadrop-search-has-results .search-modal__content,
        .header__search details[open]:has(predictive-search[open]) .search-modal__content,
        .header__search details[open]:has(predictive-search[loading]) .search-modal__content {
          grid-template-columns: 12rem minmax(0, 1fr) 6.4rem !important;
          grid-template-rows: 5.6rem minmax(0, 1fr) !important;
          column-gap: 4.4rem !important;
          row-gap: 3.2rem !important;
          padding: 1.6rem 6.8rem 3.6rem !important;
        }

        .header__search.fadrop-search-has-results predictive-search.search-modal__form,
        .header__search details[open]:has(predictive-search[open]) predictive-search.search-modal__form,
        .header__search details[open]:has(predictive-search[loading]) predictive-search.search-modal__form {
          display: contents !important;
        }

        .header__search.fadrop-search-has-results predictive-search.search-modal__form > form.search-modal__form,
        .header__search details[open]:has(predictive-search[open]) predictive-search.search-modal__form > form.search-modal__form,
        .header__search details[open]:has(predictive-search[loading]) predictive-search.search-modal__form > form.search-modal__form {
          grid-column: 1 / -1 !important;
          grid-row: 1 / 3 !important;
          display: grid !important;
          grid-template-columns: 12rem minmax(0, 1fr) 6.4rem !important;
          grid-template-rows: 5.6rem minmax(0, 1fr) !important;
          column-gap: 4.4rem !important;
          row-gap: 3.2rem !important;
          width: 100% !important;
          max-width: none !important;
          margin: 0 !important;
          padding: 0 !important;
          position: static !important;
        }

        .header__search .search-modal__form .field,
        .header__search.fadrop-search-has-results predictive-search.search-modal__form > form.search-modal__form > .field,
        .header__search details[open]:has(predictive-search[open]) predictive-search.search-modal__form > form.search-modal__form > .field,
        .header__search details[open]:has(predictive-search[loading]) predictive-search.search-modal__form > form.search-modal__form > .field {
          grid-column: 2 !important;
          grid-row: 1 !important;
          width: min(134rem, 100%) !important;
          max-width: 134rem !important;
          justify-self: center !important;
          margin: 0 !important;
        }

        .header__search.fadrop-search-has-results .predictive-search.predictive-search--header,
        .header__search details[open]:has(predictive-search[open]) .predictive-search.predictive-search--header,
        .header__search details[open]:has(predictive-search[loading]) .predictive-search.predictive-search--header {
          grid-column: 1 / -1 !important;
          grid-row: 2 !important;
          width: 100% !important;
          max-width: none !important;
          justify-self: stretch !important;
          margin: 0 !important;
        }

        .header__search.fadrop-search-has-results .predictive-search__results-groups-wrapper,
        .header__search details[open]:has(predictive-search[open]) .predictive-search__results-groups-wrapper,
        .header__search details[open]:has(predictive-search[loading]) .predictive-search__results-groups-wrapper {
          grid-template-columns: 24rem minmax(0, 1fr) !important;
          column-gap: 5.2rem !important;
          width: 100% !important;
          max-width: none !important;
        }

        .header__search.fadrop-search-has-results #predictive-search-results-products-list,
        .header__search details[open]:has(predictive-search[open]) #predictive-search-results-products-list,
        .header__search details[open]:has(predictive-search[loading]) #predictive-search-results-products-list {
          grid-template-columns: repeat(5, minmax(0, 1fr)) !important;
          column-gap: 2.4rem !important;
          width: 100% !important;
          max-width: none !important;
        }

        .header__search #predictive-search-results-products-list .fadrop-predictive-wishlist-button {
          width: clamp(3.2rem, 15%, 5.6rem) !important;
          height: clamp(3.2rem, 15%, 5.6rem) !important;
          min-width: clamp(3.2rem, 15%, 5.6rem) !important;
          min-height: clamp(3.2rem, 15%, 5.6rem) !important;
        }

        .header__search #predictive-search-results-products-list .fadrop-predictive-wishlist-button svg {
          width: 55% !important;
          height: 55% !important;
        }

        .header__search details[open] > .search-modal {
          --fadrop-desktop-searchbar-width: min(134rem, calc(100vw - 44rem));
        }

        .header__search details[open] .search-modal__form .field,
        .header__search details[open] predictive-search.search-modal__form > form.search-modal__form > .field,
        .header__search details[open] search-form.search-modal__form > form.search-modal__form > .field {
          width: var(--fadrop-desktop-searchbar-width) !important;
          min-width: var(--fadrop-desktop-searchbar-width) !important;
          max-width: var(--fadrop-desktop-searchbar-width) !important;
          justify-self: center !important;
          margin-left: auto !important;
          margin-right: auto !important;
          flex: 0 0 var(--fadrop-desktop-searchbar-width) !important;
        }

        .header__search details[open] .search-modal__content > predictive-search.search-modal__form,
        .header__search details[open] .search-modal__content > search-form.search-modal__form {
          width: var(--fadrop-desktop-searchbar-width) !important;
          max-width: var(--fadrop-desktop-searchbar-width) !important;
          justify-self: center !important;
        }

        .header__search.fadrop-search-has-results details[open] .search-modal__content > predictive-search.search-modal__form,
        .header__search details[open]:has(predictive-search[open]) .search-modal__content > predictive-search.search-modal__form,
        .header__search details[open]:has(predictive-search[loading]) .search-modal__content > predictive-search.search-modal__form {
          width: 100% !important;
          max-width: none !important;
        }

        .header__search.fadrop-search-has-results details[open] predictive-search.search-modal__form > form.search-modal__form > .field,
        .header__search details[open]:has(predictive-search[open]) predictive-search.search-modal__form > form.search-modal__form > .field,
        .header__search details[open]:has(predictive-search[loading]) predictive-search.search-modal__form > form.search-modal__form > .field {
          width: var(--fadrop-desktop-searchbar-width) !important;
          min-width: var(--fadrop-desktop-searchbar-width) !important;
          max-width: var(--fadrop-desktop-searchbar-width) !important;
        }

        .header__search details[open] .search-modal__form .field {
          position: relative !important;
          overflow: visible !important;
        }

        .header__search details[open] .search__input.field__input {
          padding-right: 7rem !important;
        }

        .header__search details[open] .reset__button {
          position: absolute !important;
          top: 50% !important;
          right: 1.25rem !important;
          display: grid !important;
          place-items: center !important;
          width: 3.6rem !important;
          height: 3.6rem !important;
          min-width: 3.6rem !important;
          min-height: 3.6rem !important;
          margin: 0 !important;
          padding: 0 !important;
          border: 0 !important;
          border-radius: 999rem !important;
          background: transparent !important;
          color: #111 !important;
          transform: translateY(-50%) !important;
          box-shadow: none !important;
          opacity: 1 !important;
          visibility: visible !important;
          flex: none !important;
          z-index: 5 !important;
        }

        .header__search details[open] .reset__button.hidden {
          display: grid !important;
          opacity: 0 !important;
          visibility: hidden !important;
          pointer-events: none !important;
        }

        .header__search details[open] .reset__button:before,
        .header__search details[open] .reset__button:after {
          display: none !important;
          content: none !important;
        }

        .header__search details[open] .reset__button:hover,
        .header__search details[open] .reset__button:focus-visible {
          background: #e8e8e8 !important;
          border-radius: 999rem !important;
        }

        .header__search details[open] .fadrop-search-clear-icon,
        .header__search details[open] .fadrop-search-clear-icon svg {
          display: block !important;
          width: 2.2rem !important;
          height: 2.2rem !important;
        }

        .header__search.fadrop-search-has-results .predictive-search__result-group:nth-child(2) > .predictive-search__heading,
        .header__search.fadrop-search-has-results .predictive-search__result-group:last-child > .predictive-search__heading,
        .header__search details[open]:has(predictive-search[open]) .predictive-search__result-group:nth-child(2) > .predictive-search__heading,
        .header__search details[open]:has(predictive-search[open]) .predictive-search__result-group:last-child > .predictive-search__heading,
        .header__search details[open]:has(predictive-search[loading]) .predictive-search__result-group:nth-child(2) > .predictive-search__heading,
        .header__search details[open]:has(predictive-search[loading]) .predictive-search__result-group:last-child > .predictive-search__heading,
        .header__search #predictive-search-products,
        .header__search #predictive-search-results-products-list-heading {
          display: none !important;
          height: 0 !important;
          min-height: 0 !important;
          margin: 0 !important;
          padding: 0 !important;
          border: 0 !important;
          overflow: hidden !important;
          line-height: 0 !important;
          font-size: 0 !important;
        }

        .header__search details[open] .search__input.field__input:placeholder-shown ~ .reset__button,
        .header__search details[open] .search__input.field__input[value=""] ~ .reset__button {
          display: grid !important;
          opacity: 0 !important;
          visibility: hidden !important;
          pointer-events: none !important;
        }

        .header__search details[open] .search__input.field__input:not(:placeholder-shown) ~ .reset__button {
          display: grid !important;
          opacity: 1 !important;
          visibility: visible !important;
          pointer-events: auto !important;
        }
      }
    `;
    document.head.appendChild(style);
  };

  const syncSearchEmptyState = () => {
    document.querySelectorAll('.header__search predictive-search').forEach((search) => {
      const shell = search.closest('.header__search');
      if (!shell) return;

      const hasResults = search.hasAttribute('results');
      const hasResultGroups = Boolean(search.querySelector('.predictive-search__results-groups-wrapper'));
      shell.classList.toggle('fadrop-search-has-results', hasResults && hasResultGroups);
      shell.classList.toggle('fadrop-search-empty-results', hasResults && !hasResultGroups);
    });
  };

  const observer = new MutationObserver(syncSearchEmptyState);

  const watchSearches = () => {
    injectCompactDesktopResultsCss();
    document.querySelectorAll('.header__search predictive-search').forEach((search) => {
      observer.observe(search, { attributes: true, childList: true, subtree: true });
    });
    syncSearchEmptyState();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watchSearches, { once: true });
  } else {
    watchSearches();
  }
})();
